(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightHandler);

      this.observeHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    /* THE DAWN DEFECT THIS FIXES.
       --header-height is Dawn's own contract for "how tall is the header right now", and
       everything that pins itself below the header reads it: base.css's
       .shopify-section-header-hidden, and on this theme the /compete chapter bar's sticky
       `top` plus the #divisions and .band jump landings (scroll-margin-top).
       Stock Dawn published it exactly ONCE, from connectedCallback, and after that only on a
       (max-width: 990px) media change. But sticky_header_type here is `reduce-logo-size`,
       which injects `.scrolled-past-header .header__heading-logo-wrapper{width:75%}`. The
       logo carries .header__heading-logo{height:auto}, so 75% of its width is also 75% of
       its height and the header loses a quarter of the logo box -- measured on this theme,
       20.127px -- the moment .scrolled-past-header engages. The property stayed frozen at
       the TALL value while the header was short, so every consumer sat in a ~20px gap below
       the header's real bottom edge, in BOTH scroll directions, until you scrolled all the
       way back to the very top (Dawn only drops the class at scrollTop <= headerBounds.top).
       Three things were needed, and all three are here:
       1. getBoundingClientRect().height, not offsetHeight. offsetHeight rounds this header's
          113.604 to 114 and 93.477 to 93, so even at rest it left a 0.391px seam.
       2. Re-measure whenever .scrolled-past-header toggles -- see setScrolledPastHeader().
       3. .header__heading-logo-wrapper carries `transition: width .3s`, so the height
          ANIMATES rather than stepping. A single measurement taken at toggle time reads the
          OLD height and is wrong for the whole 300ms sweep, so a ResizeObserver on the
          header tracks every frame of it and a transitionend on the wrapper pins the
          settled value. Guarded at > 0: a ResizeObserver reports 0 while the section is
          being re-rendered in the theme editor, and publishing 0px would collapse every
          consumer. */
    setHeaderHeight() {
      const height = this.header.getBoundingClientRect().height;
      if (height > 0) {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }

    observeHeaderHeight() {
      /* The ResizeObserver is the load-bearing one: its callback runs after layout and
         before paint, so a corrected offset lands in the same frame as the resize and there
         is no flash of seam. It catches the class toggle, every frame of the .3s width
         sweep, the 990px breakpoint, and a logo or webfont that finishes loading after the
         first measurement -- all in one place. */
      if (window.ResizeObserver) {
        this.headerHeightObserver = new ResizeObserver(this.setHeaderHeightHandler);
        this.headerHeightObserver.observe(this.header);
      }

      /* transitionend is the belt to that braces: it guarantees the exact settled height
         even if the last resize frame is coalesced away, and it is the only transition-aware
         path in a browser without ResizeObserver. */
      this.logoWrapper = this.querySelector('.header__heading-logo-wrapper');
      if (this.logoWrapper) {
        this.onLogoTransitionEnd = (event) => {
          if (event.propertyName === 'width') this.setHeaderHeight();
        };
        this.logoWrapper.addEventListener('transitionend', this.onLogoTransitionEnd);
      }
    }

    /* Requirement 2. Every .scrolled-past-header toggle goes through here, so the height is
       re-measured the instant the class state actually changes -- which also gives a browser
       with no ResizeObserver a correct first step. Guarded on a real change, so this is
       behaviourally identical to the classList.add/remove calls it replaces (add on an
       element that already has the class was always a no-op). */
    setScrolledPastHeader(isScrolledPast) {
      if (this.header.classList.contains('scrolled-past-header') === isScrolledPast) return;
      this.header.classList.toggle('scrolled-past-header', isScrolledPast);
      this.setHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerHeightObserver) this.headerHeightObserver.disconnect();
      if (this.logoWrapper && this.onLogoTransitionEnd) {
        this.logoWrapper.removeEventListener('transitionend', this.onLogoTransitionEnd);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPastHeader(true);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPastHeader(true);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.setScrolledPastHeader(false);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
